cbp-universal-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  color-scheme: dark;
  color: var(--cbp-color-text-lightest);
  background-color: var(--cbp-color-branding-dhs-blue);
  min-height: var(--cbp-space-16x);
  width: 100%;
  padding: 0 var(--cbp-responsive-spacing-outer);

  .cbp-universal-header__brand {
    align-items: center;
    display: flex;

    &::after {
      content: 'CBP';
      font-size: var(--cbp-font-size-heading-xl);
      margin-left: var(--cbp-space-2x);
    }
  }

  // Tech Debt: this should probably be replaced with cbp-flex in the story to achieve this functionality explicitly
  .cbp-universal-header__content {
    ul,
    ol {
      display: flex;
      gap: var(--cbp-space-4x);
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: inline;
      }
    }
  }
}

@media (min-width: $cbp-breakpoint-md) {
  cbp-universal-header {
    min-height: 4rem;

    .cbp-universal-header__brand::after {
      content: '';
    }
  }
}